<mat-form-field floatLabel="always">
  <mat-label></mat-label>
  <mat-chip-list #chipList aria-label="Specialties selection">
    <mat-chip
      (removed)="removeSpecialty(specialty.value)"
      *ngFor="let specialty of specialtiesFormArray.controls"
      [removable]="removable"
      [selectable]="selectable"
    >
      {{ specialty.get('name').value }}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip>
    <input
      #specialtyInput
      [formControl]="specialtyCtrl"
      [matAutocomplete]="auto"
      [matChipInputAddOnBlur]="addOnBlur"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      placeholder="Enter Specialty"
    />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" [autoActiveFirstOption]="true" (optionSelected)="selectSpecialty($event)">
    <mat-option *ngFor="let item of this.filteredSpecialties | async" [value]="item">
      {{ item.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
